export default function AppLogoIcon({ className }: { className?: string }) {
    return (
        <img
            src="/logo.png"
            alt=""
            className={className}
        />
    );
}
